var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.797,
    height: 46.797,
    viewBox: "0 0 46.797 46.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_21_Handset_6",
    "data-name": "21 Handset_6",
    d: "M30.391,56a23.4,23.4,0,1,1,16.545-6.853A23.246,23.246,0,0,1,30.391,56ZM20.7,18.047a2.807,2.807,0,0,0-1.971.817l-.184.185a8.482,8.482,0,0,0-1.156,10.569,50.449,50.449,0,0,0,16,15.963,8.522,8.522,0,0,0,10.568-1.156l.185-.184A2.784,2.784,0,0,0,43.768,40l-5.406-3.777a2.759,2.759,0,0,0-3.557.312l-.231.219A2.1,2.1,0,0,1,32,37.1,17.487,17.487,0,0,1,25.876,31a2.1,2.1,0,0,1,.347-2.575l.219-.231a2.75,2.75,0,0,0,.312-3.557l-3.777-5.406a2.777,2.777,0,0,0-2.039-1.177C20.858,18.051,20.777,18.047,20.7,18.047Z",
    transform: "translate(-6.992 -9.203)",
    fill: "#f5f5f5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c7be3b611332b65b747d1dd223e85c4c.svg";
export { ForwardRef as ReactComponent };